import React from "react";
import Alert, { AlertProps } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";

interface CustomAlertProps extends AlertProps {
  header: React.ReactNode | string;
  textMessages?: string[];
}

const CustomAlert: React.FC<CustomAlertProps> = ({ header, textMessages, ...props }) => {
  return (
    <Alert {...props}>
      {textMessages != null ? (
        <React.Fragment>
          <AlertTitle>{header}</AlertTitle>
          {textMessages.map((m, i) => (
            <Typography key={i} variant="body2">
              {m}
            </Typography>
          ))}
        </React.Fragment>
      ) : (
        header
      )}
    </Alert>
  );
};

export default CustomAlert;
